import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface, } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/romancebrawl.webp";


export const projectDetails: ProjectInterface = {
    url: "romance-brawl",
    title: "Romance Brawl",
    summary: "An One Piece tribute game for educational purposes.",
    description: `This project was a fan-made game of One Piece. My friend and I started working on it together as a way to study game dev, but we never finished the project. It was meant to be a multiplayer game similar to Smash Bros., and we used [Light Reflective Mirror](https://github.com/Derek-R-S/Light-Reflective-Mirror) for the networking.

        Since I shut down the game servers the demo is not available anymore.`,
    year: "2022",
    tags: ["Action", "Fighting", "Multiplayer", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.PROTOTYPE,
    roles: ["Multiplayer Programmer", "Prototype"],
    technologies: ["Unity", "C#", "Multiplayer"],
    collaborators: ["Lucas Coutinho", "[link=rafaelmgk|https://github.com/rafaelmgk]"],
    highlightColor: "#60151F",
    descriptionTitle: "Exploring multiplayer game development",
    linkData:
    [
        { type: 'github', url: "https://github.com/rafaelmgk/Romance-Brawl" },
        { type: 'text', url: "https://github.com/rafaelmgk/Romance-Brawl" },
    ],
    relatedProjects: ["ProceduralStudy", "CheckMore"],
};


export function RomanceBrawl() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    null
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}